import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font-files/grand-hotel-latin-ext-normal-97b1f2c1.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22script%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0100-02BA,%20U+02BD-02C5,%20U+02C7-02CC,%20U+02CE-02D7,%20U+02DD-02FF,%20U+0304,%20U+0308,%20U+0329,%20U+1D00-1DBF,%20U+1E00-1E9F,%20U+1EF2-1EFF,%20U+2020,%20U+20A0-20AB,%20U+20AD-20C4,%20U+2113,%20U+2C60-2C7F,%20U+A720-A7FF%22}]}],%22variableName%22:%22scriptLatinExt%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'scriptLatinExt'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
